<div class="container-fluid">
    <div class="row ">
        <div class="col-lg-4">
        </div>
        <!-- <div class="col-lg-4 text-center">
            <h2><b>Price Matrix</b></h2>
        </div> -->
        <div class="col-lg-4">
        </div>
    </div>
</div>
<div nz-row [nzJustify]="'center'" *ngIf="isLoading" class="loading-spinner">
  <nz-spin nzSimple></nz-spin>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12 text-center" style="padding-left: 5%;padding-right: 4%;">
<div >
  <nz-tabset nzCentered nzSize="large">
    <nz-tab *ngFor="let pmlist of pricingMatrixObj.priceMatrixList; let j =index" [nzTitle]="authService.user.isPremium ? pmlist.name : ''" (nzSelect)="tabChanged(j)" [nzDisabled]="this.matrixDirty">
      <div class="col-lg-12 text-center" style="padding-left: 5%;padding-right: 4%;" *ngIf="authService.user.isPremium">
        <p><b>{{ pmlist.description }}</b></p>
      </div>
      <div nz-row style="padding-bottom: 5px;" [nzJustify]=" 'space-between' ">
        <div nz-col nzSpan="8">
            <nz-select [(ngModel)]="pmlist.applied"  style="width: 100%" [nzPlaceHolder]="'Select Price Matrix'" (ngModelChange)="openApplyModal(j)" *ngIf="authService.user.isPremium">
                <nz-option *ngFor="let item of matrixOptions" [nzLabel]="item.text" [nzValue]="item.id"></nz-option>
            </nz-select>
  
        </div>
        <div >
            <button nz-button nzType="primary" type="submit" (click)="updatePMList(j)" [disabled]="!matrixDirty">Save</button>
        </div>
    </div>
      <nz-table  #pricingMatrixTable [nzData]="pmlist.priceMatrixItems" [nzFrontPagination]="false" [nzPageSize]="100" [nzPaginationPosition]="'both'" [nzLoading]="isLoadingMatrix">
        <thead>
          <tr>
            <th nzWidth="20px"></th>
            <th 
                [nzSortOrder]="priceMatrixBrandColumn.sortOrder"
                [nzSortFn]="priceMatrixBrandColumn.sortFn"
                [nzSortDirections]="priceMatrixBrandColumn.sortDirections"
                [nzFilterMultiple]="priceMatrixBrandColumn.filterMultiple"
                [nzFilters]="priceMatrixBrandColumn.listOfFilter"
                [nzFilterFn]="priceMatrixBrandColumn.filterFn"
                nzWidth="170px">
              {{ priceMatrixBrandColumn.name }}
            </th>
            <th nzWidth="150px">Method</th>
            <th nzWidth="175px">Percentage
              <button nz-button nzType="primary" style="margin-left: 10px;" nz-popover nzPopoverTitle="Set All %" [nzPopoverContent]="setAllTemplate" nzPopoverPlacement="right" nzPopoverTrigger="click" (click)="this.popOverVisibility = !this.popOverVisibility" (nzPopoverVisible)="this.popOverVisibility">Set All Brand Defaults</button>
              <ng-template #setAllTemplate>
                <div>
                  <nz-input-group nzAddOnBeforeIcon="percentage">
                    <input nz-input [(ngModel)]="this.setAllValue" type="number" placeholder="20" style="width: 100px;">
                  </nz-input-group>
                  <div nz-row [nzJustify]="'end'">
                    <button nz-button nzType="primary" style="margin-top: 10px;" (click)="setAllPercentages(j); this.popOverVisibility = false;">Set Brand Defaults</button>
                  </div>
                </div>
              </ng-template>
              <app-video-widget [videoId]="6" style="float: inline-end;"></app-video-widget>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="pmlist.applied">
          <ng-container *ngFor="let brand of pricingMatrixTable.data; let i = index;">
            <!-- Brand Row -->
            <tr [ngClass]="{'text-danger': !brand.pmId}">
              <!-- <td  nz-popover nzPopoverContent="Click to modify Rim Sizes" nzPopoverTrigger="hover"><span nz-icon nzType="plus-circle" nzTheme="outline"></span></td> -->
              <td [(nzExpand)]="brand.expand" [nzShowExpand]="true"  nz-popover nzPopoverContent="Click to modify Rim Sizes" nzPopoverTrigger="hover"><img class="brandImage" src='https://sftptyres.blob.core.windows.net/brands-images/brands/{{brand.image}}' ></td>
              <td [nzIndentSize]="(brand?.level ?? 0) * 20" >{{ brand.brandName }} <span nz-icon nzType="loading" nzTheme="outline" *ngIf="brand.loading"></span></td>
              <td>
                <button nz-button *ngIf="!brand.methodEditable" nzType="primary" (click)=" brand.methodEditable = true" nz-popover nzPopoverContent="Click to modify method" nzPopoverTrigger="hover" style="width: 50%">
                  {{ brand.methodId == 1 ? 'Fixed GP Percent' : brand.methodId == 2 ? 'Retail Less' : 'Dont Sell' }}
                </button>
                <nz-radio-group *ngIf="brand.methodEditable" nzSize="small" nzButtonStyle="solid" [(ngModel)]="brand.methodId" (ngModelChange)="matrixBrandChanged([brand], j, brand.value); brand.methodEditable = false" style="width: 75%"  >
                  <label nz-radio-button [nzValue]="1">Fixed GP Percent</label>
                    <label nz-radio-button [nzValue]="2">Retail Less</label>
                    <label nz-radio-button  [nzValue]="3">Dont Sell</label>
                </nz-radio-group>
                <button nz-button *ngIf="brand.methodEditable" nzType="primary" nzDanger="true" (click)="brand.methodEditable = false"><span nz-icon nzType="close" nzTheme="outline"></span></button>
              </td>
              <td>
                <div class="input-group maindiv" style="width: 100%">
                  <nz-input-group nzAddOnAfterIcon="percentage" >
                    <input nz-input [(ngModel)]="brand.value" (ngModelChange)="brand.methodId && matrixBrandChanged([brand], j, $event)" type="number" placeholder="100">
                  </nz-input-group>
                </div>
              </td>
            </tr>
            <!-- Rim Rows -->
            <ng-container *ngIf="brand.expand && brand.priceMatrixOverrideItems">
              <tr *ngFor="let item of brand.priceMatrixOverrideItems">
                <td></td>
                <td [nzIndentSize]="15"> 
                  <div nz-row nzJustify="space-evenly">
                    <div nz-col nzSpan="12" class="text-center">
                      {{ item.rimSize ? item.rimSize + '"' : 'All Rim Sizes' }}
                    </div>
                    <div nz-col nzSpan="12" class="text-center">
                      {{ item.market ? item.market : 'All Markets' }}
                    </div>
                  </div>
                  <!-- {{ item.rimSize }}" {{item.market}}</td> -->
                <td>
                  <button nz-button *ngIf="!item.methodEditable" nzType="primary" (click)="item.methodEditable = true" nz-popover nzPopoverContent="Click to modify method" nzPopoverTrigger="hover" style="width: 50%">
                    {{ item.pmMethodId == 1 ? 'Fixed GP Percent' : item.pmMethodId == 2 ? 'Retail Less' : 'Dont Sell' }}
                  </button>
                  <nz-radio-group nzSize="small" *ngIf="item.methodEditable" nzButtonStyle="solid"  [ngModel]="item.pmMethodId" (ngModelChange)="matrixOverrideChanged(item,j,$event,item.value); item.methodEditable= false" style="width: 75%" >
                    <label nz-radio-button [nzValue]="1">Fixed GP Percent</label>
                    <label nz-radio-button [nzValue]="2">Retail Less</label>
                    <label nz-radio-button  [nzValue]="3">Dont Sell</label>
                  </nz-radio-group>
                  <button nz-button *ngIf="item.methodEditable" nzType="primary" nzDanger="true" (click)="item.methodEditable = false"><span nz-icon nzType="close" nzTheme="outline"></span></button>
                </td>
                <td>
                  <div nz-row [nzJustify]="'space-between'">
                    <div nz-col nzSpan="18">
                      <nz-input-group nzAddOnAfterIcon="percentage">
                        <input nz-input [ngModel]="item.value" (ngModelChange)="matrixOverrideChanged(item, j, item.pmMethodId, $event)" type="number" placeholder="100">
                      </nz-input-group>
                    </div>
                    <div nz-col style="margin-left:10px">
                      <button nz-button nzType="primary" nzDanger="true" (click)="deleteOverrideItem(item,j)"><span nz-icon nzType="delete" nzTheme="outline"></span></button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Add Override Rule</td>
                <td [nzIndentSize]="((brand?.level ?? 0) + 1) * 10">
                  <nz-select style="width: 45%" [(ngModel)]="newRule[brand.brandId].size" nzShowSearch="true" nzPlaceHolder="Select Rim Size" (ngModelChange)="newRule[brand.brandId].size = $event">
                    <nz-option *ngFor="let size of this.avaibleRims(brand.brandId, j)" [nzLabel]="size" [nzValue]="size"></nz-option>
                  </nz-select>
                  <nz-select style="width: 40%; margin-left: 12px;" [(ngModel)]="newRule[brand.brandId].market" nzShowSearch="true" nzPlaceHolder="Select Market" (ngModelChange)="newRule[brand.brandId].market = $event">
                    <nz-option *ngFor="let market of this.availableMarkets(brand.brandId, j)" [nzLabel]="market" [nzValue]="market"></nz-option>
                  </nz-select>
                </td>
                <td>
                    <nz-radio-group nzSize="small" nzButtonStyle="solid" [(ngModel)]="newRule[brand.brandId].methodId" style="width: 100%">
                      <label nz-radio-button [nzValue]="1">Fixed GP Percent</label>
                      <label nz-radio-button [nzValue]="2">Retail Less</label>
                      <label nz-radio-button  [nzValue]="3">Dont Sell</label>
                  </nz-radio-group>
                </td>
                <td>
                  <div nz-row [nzJustify]="'space-between'">
                    <div nz-col nzSpan="18">
                      <nz-input-group nzAddOnAfterIcon="percentage">
                        <input nz-input [(ngModel)]="newRule[brand.brandId].value" type="number" placeholder="100">
                      </nz-input-group>
                    </div>
                    <div nz-col >
                      <button nz-button nzType="primary" [disabled]="!newRule[brand.brandId].methodId || newRule[brand.brandId].value==0 || (!newRule[brand.brandId].size && !newRule[brand.brandId].market) || !brand.pmId" (click)="brand.pmId && (newRule[brand.brandId].size || newRule[brand.brandId].market) && addNewRule(j, brand.brandId, brand.pmId)">Add Rule</button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
        <tbody *ngIf="!pmlist.applied">
          <tr>
            <td ></td>
            <td colspan="3" style="text-align: center;">The price matrix for this price list has been disabled</td>
          </tr>

        </tbody>
      </nz-table>

      <nz-modal [(nzVisible)]="isApplyModalVisible" nzTitle="Remove Price Matrix" (nzOnCancel)="isApplyModalVisible = false;" [nzFooter]="null" nzWidth="800px">
        <div *nzModalContent>
            <div nz-row [nzGutter]="5" [nzJustify]="'center'">
      
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;">
                    <p style="size: 16px; font-weight: bold; text-align: center; margin-bottom: 20px;">
                      This action will erase all current price matrix rules for this price list.
                    </p>
                    <p style="size: 16px; font-weight: bold; text-align: center; margin-bottom: 10px;">
                      Continue?
                    </p>
                    <div nz-row [nzJustify]="'space-between'">
                        <button nz-button nzType="primary" (click)="deletePriceMatrixRules()" >
                          <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                          Continue
                        </button>
                        <button nz-button nzType="primary" (click)="cancelApply()">
                            <i nz-icon nzType="close-circle" nzTheme="fill"></i>
                            Cancel
                        </button>
                  </div>
                </div>
            </div>
        </div>
      </nz-modal>
    </nz-tab>
    
  </nz-tabset>
  <nz-modal [(nzVisible)]="isNavModalVisible" nzTitle="Save Changes" (nzOnCancel)="isNavModalVisible = false; navPathAway='';" [nzFooter]="null" nzWidth="800px">
    <div *nzModalContent>
        <div nz-row [nzGutter]="5" [nzJustify]="'center'">
            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;">
                <br>
                <p>Do you want to save changes before leaving?</p>
                <div nz-row [nzJustify]="'space-between'">
                    <button nz-button nzType="primary" (click)="navigateWithSaving();">
                      <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                      Save Changes
                    </button>
                    <button nz-button nzType="primary" (click)="navigateWithoutSaving()">
                        <i nz-icon nzType="left-circle" nzTheme="fill"></i>
                        Continue Without Saving
                    </button>
              </div>
            </div>
        </div>
    </div>
</nz-modal>





</div>
            
        </div>
    </div>
</div>